import React from 'react'
import PropTypes from 'prop-types'
import { useBodyOverlay, useCallback } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { constants, links, snowplow } from 'common/helpers'
import { getCookieValue } from 'helpers'
import actions from 'redux/actions'

import Box from 'components/_new/layout/Box/Box'
import Logo from 'components/ui/Logo/Logo'
import HeaderBanner from 'layouts/InsideLayout/Header/HeaderBanner/HeaderBanner'
import SearchInput from 'layouts/InsideLayout/Header/HeaderSearchInput/HeaderSearchInput'
// import AlgoliaSearchInput from 'layouts/InsideLayout/Header/HeaderAlgoliaSearchInput/HeaderAlgoliaSearchInput'

import HamburgerButton from './HamburgerButton/HamburgerButton'
import CartButton from './CartButton/CartButton'
import ProfileButton from './ProfileButton/ProfileButton'

import s from './MobileNewHeader.scss'


const MobileNewHeader = ({ withSearchInput, withGiftSetsBanner }) => {
  const { isSomeSidebarOpened, isNotEmptyPage, isSkincareIntroPage } = useConnect({
    isSomeSidebarOpened: (state) => state.models.ui.isSideMenuVisible || state.models.ui.isProfileMenuVisible,
    isNotEmptyPage: (state) => {
      const { routing: { location: { pathname } } } = state

      return (
        pathname !== links.subscription.mainMenEmpty
        && pathname !== links.subscription.mainWomenEmpty
      )
    },
    isSkincareIntroPage: (state) => {
      const { routing: { location: { pathname } } } = state

      return pathname === links.skincareIntro
    },
  })

  const trackMenuFirstClick = useCallback((type) => {
    // use helper to get actual cookie value when fired
    const isEventWasFired = getCookieValue(constants.cookieNames.mobileMenuFirstClick, true)

    if (!isEventWasFired) {
      snowplow.track(constants.snowplowEvents.mobileMenuFirstClick, { type }, true)
      actions.misc.cookies.setItem(constants.cookieNames.mobileMenuFirstClick, true)
    }
  }, [])

  useBodyOverlay(isSomeSidebarOpened)

  return (
    <div className={s.headerContainer}>
      <header className={s.header}>
        <Box className={s.item} mr="8" ml="8">
          <HamburgerButton className={s.button} onOpen={trackMenuFirstClick} />
        </Box>
        <Box className={s.item} mr="8" ml="8">
          {
            isNotEmptyPage && (
              <CartButton className={s.button} />
            )
          }
        </Box>
        <Box className={s.logoContainer} alignCenter mr="8" ml="8">
          <Logo light redirect={!isSkincareIntroPage && links.home} />
        </Box>
        <Box className={s.item} mr="8" ml="8" />
        <Box className={s.item} mr="8" ml="8">
          <ProfileButton className={s.button} onOpen={trackMenuFirstClick} />
        </Box>
      </header>
      {
        withSearchInput && (
          <SearchInput isMobile />
        )
      }
      {
        withGiftSetsBanner && (
          <HeaderBanner />
        )
      }
    </div>
  )
}

MobileNewHeader.propTypes = {
  withSearchInput: PropTypes.bool,
  withGiftSetsBanner: PropTypes.bool,
}

MobileNewHeader.defaultProps = {
  withSearchInput: true,
  withGiftSetsBanner: true,
}


export default MobileNewHeader
